import { motion } from 'framer-motion';
import { useLanguage } from '@/context/LanguageContext';
import translations from '@/utils/translations';

export default function VirtualTour() {
  const { language } = useLanguage();
  const t = translations[language].tour;

  return (
    <section id="tour" className="py-20 md:py-32 bg-[#e3e6e8]" data-testid="tour-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#5b6770] mb-4">
            {t.title}
          </h2>
          <p className="text-[#5b6770] text-lg max-w-2xl mx-auto">
            {t.description}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative rounded-3xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.08)] border border-gray-100 bg-white"
        >
          <div className="absolute top-4 left-4 z-10 bg-white/90 backdrop-blur-md px-4 py-2 rounded-xl shadow-sm">
            <p className="text-sm font-medium text-[#5b6770]">Tour virtual</p>
          </div>

          <iframe
            src="https://www.google.com/maps/embed?pb=!4v1776014212539!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ0Vwc3lFRmc.!2m2!1d41.40790761447738!2d2.137783332621276!3f137.7439927458877!4f-1.947845387924147!5f0.7820865974627469"
            width="100%"
            height="620"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-[420px] md:h-[540px] lg:h-[620px]"
          ></iframe>

          <div className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-black/5" />
        </motion.div>
      </div>
    </section>
  );
}